import React, { useState, useEffect } from 'react';
import ArztList from '../components/arzt/ArztList';
import ArztForm from '../components/arzt/ArztForm';
import DeleteArztDialog from '../components/arzt/DeleteArztDialog';
import { Arzt, Praxis, AppType } from '../types';
import { praxisService } from '../services/praxis.service';
import { useEnvironment } from '../context/EnvironmentContext';

type ViewMode = 'list' | 'create' | 'edit';

const ArztPage: React.FC = () => {
  const { currentApp } = useEnvironment();
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selectedArzt, setSelectedArzt] = useState<Arzt | null>(null);
  const [arztToDelete, setArztToDelete] = useState<Arzt | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [availablePraxen, setAvailablePraxen] = useState<Praxis[]>([]);

  useEffect(() => {
    const fetchPraxen = async () => {
      try {
        const praxen = await praxisService.getAllPraxen(currentApp as AppType);
        setAvailablePraxen(praxen);
      } catch (error) {
        console.error('Failed to fetch practices:', error);
      }
    };
    fetchPraxen();
  }, [currentApp]);

  const handleCreate = () => {
    setSelectedArzt(null);
    setViewMode('create');
  };

  const handleEdit = (arzt: Arzt) => {
    setSelectedArzt(arzt);
    setViewMode('edit');
  };

  const handleDelete = (arzt: Arzt) => {
    setArztToDelete(arzt);
  };

  const handleFormSuccess = () => {
    setViewMode('list');
    setSelectedArzt(null);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleFormCancel = () => {
    setViewMode('list');
    setSelectedArzt(null);
  };

  const handleDeleteSuccess = () => {
    setArztToDelete(null);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleDeleteCancel = () => {
    setArztToDelete(null);
  };

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Ärzte</h1>

      {viewMode === 'list' ? (
        <ArztList
          onEdit={handleEdit}
          onDelete={handleDelete}
          onCreate={handleCreate}
          refreshTrigger={refreshTrigger}
        />
      ) : (
        <ArztForm
          arzt={viewMode === 'edit' ? selectedArzt : null}
          availablePraxen={availablePraxen}
          onSuccess={handleFormSuccess}
          onCancel={handleFormCancel}
        />
      )}

      {arztToDelete && (
        <DeleteArztDialog
          arzt={arztToDelete}
          onSuccess={handleDeleteSuccess}
          onCancel={handleDeleteCancel}
        />
      )}
    </div>
  );
};

export default ArztPage;
